import IAddress from "./Address";
import Entity from "./Entity";
import IUser from "./User";

export interface IMei extends Entity {
	cpf?: string;
	code?: string;
	birthDate?: Date;
	hasMei?: boolean;
	invalidBirthDate?: boolean;
	cnpj?: string;
	businessName?: string;
	personName?: string;
	socialName?: string;
	shareCapital?: string;
	rg?: string;
	rgEmissor?: string;
	rgEmissorState?: string;
	situation?: string;
	openingDate?: string;
	nire?: string;
	startDate?: string;
	operationMode?: string;
	occupation?: string;
	activity?: string;
	receiptNumber?: string;
	identificatorNumber?: string;
	emissionDate?: string;
	type?: CompanyType;
	address?: string | IAddress;
	user?: string | IUser;
	govBrPassword?: string;
	logisticOperator?: IMei;
	logisticOperatorStatus?: MeiLogisticOperatorStatus;
	/** Controller company (MEI) that owns this logistic operator. Set on operator MEIs only. */
	parentOperator?: IMei;
}

export enum MeiLogisticOperatorStatus {
	None = 0,
	Actived = 1,
	Inactive = 2,
	Fired = 3
}

export enum CompanyType {
	Mei = 0,
	Me = 1
}

export enum MeiSituation {
	ATIVA = "ATIVA",
	BAIXADO = "BAIXADO",
	NAO_ENQUADRADO = "NAO_ENQUADRADO",
	NAO_ATIVO = "NAO_ATIVO",
	NECESSITA_ALTERAR_OCUPACOES = "NECESSITA_ALTERAR_OCUPACOES",
	CNPJ_INVALIDO = "CNPJ_INVALIDO"
}

export default IMei;
